export const settings = {
   defaultLang: 'pl-PL',
   fallbackLang: 'pl-PL',
}

export const locales = [
   {
      prefix: 'pl-PL',
      name: 'Polski',
   },
   {
      prefix: 'en-EN',
      name: 'English',
   },
   {
      prefix: 'de-DE',
      name: 'Deutsch',
   },
]
